import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export type StyledCardProps = {
  width?: number;
  isClickable?: boolean;
};

export const StyledCard = styled.div<StyledCardProps>`
  ${({ theme, width, isClickable }) => `
    background-color: ${theme.Color.Neutrals.Paper};
    display: flex;
    ${width && `width: ${utils.rem(width)}`};
    padding: ${utils.rem(theme.Spacing.Size.Small)};
    border-radius: ${utils.rem(theme.Spacing.Size.Small)};
    border: ${utils.rem(theme.Card.Border.Size.Small)} solid ${theme.Color.Neutrals.Light};
    transition: all 200ms ease-in-out;
    &:hover {
      ${isClickable && `border-color: ${theme.Color.Brand.Primary}`};
    };
    & .ant-image-mask {
      border-radius: ${utils.rem(theme.Spacing.Size.Small)};
    }
  `}
`;
